"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.notificationServiceFactory = void 0;
var hasNotificationSupport = function (win) {
    return typeof win.Notification !== 'undefined';
};
var hasServiceWorkerSupport = function (win) {
    return typeof win.navigator !== 'undefined' && 'serviceWorker' in win.navigator;
};
/** PushManager lives on window / SW registration — not navigator. */
var hasPushManagerSupport = function (win) {
    var w = win;
    if (typeof w.PushManager !== 'undefined') {
        return true;
    }
    return (typeof w.ServiceWorkerRegistration !== 'undefined' &&
        w.ServiceWorkerRegistration.prototype &&
        'pushManager' in w.ServiceWorkerRegistration.prototype);
};
var invokeFallback = function (fallback, title, body) {
    if (fallback && typeof fallback.onFallback === 'function') {
        fallback.onFallback(title, body);
        return true;
    }
    return false;
};
var BrowserNotificationService = /** @class */ (function () {
    function BrowserNotificationService($window, $q) {
        this.$window = $window;
        this.$q = $q;
    }
    BrowserNotificationService.prototype.supportsPush = function () {
        return (hasNotificationSupport(this.$window) &&
            hasServiceWorkerSupport(this.$window) &&
            hasPushManagerSupport(this.$window));
    };
    BrowserNotificationService.prototype.requestPermission = function () {
        if (!hasNotificationSupport(this.$window)) {
            return this.$q.reject('Notifications not supported');
        }
        var NotificationCtor = this.$window.Notification;
        try {
            var result = NotificationCtor.requestPermission();
            // Modern browsers return a Promise; older take a callback.
            if (result && typeof result.then === 'function') {
                return this.$q.when(result);
            }
            return this.$q(function (resolve, reject) {
                try {
                    NotificationCtor.requestPermission(function (perm) { return resolve(perm); });
                }
                catch (e) {
                    reject(e);
                }
            });
        }
        catch (e) {
            return this.$q.reject(e);
        }
    };
    BrowserNotificationService.prototype.showNotification = function (title, options, fallback) {
        return this.$q.when(this.showNotificationInternal(title, options, fallback));
    };
    BrowserNotificationService.prototype.showNotificationInternal = function (title, options, fallback) {
        return __awaiter(this, void 0, void 0, function () {
            var permission, requested, registration, _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!hasNotificationSupport(this.$window)) {
                            return [2 /*return*/, invokeFallback(fallback, title, options === null || options === void 0 ? void 0 : options.body) ? 'fallback' : 'unsupported'];
                        }
                        permission = this.$window.Notification.permission;
                        if (permission === 'denied') {
                            return [2 /*return*/, invokeFallback(fallback, title, options === null || options === void 0 ? void 0 : options.body) ? 'fallback' : 'blocked'];
                        }
                        if (!(permission === 'default')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.$window.Notification.requestPermission()];
                    case 1:
                        requested = _b.sent();
                        if (requested !== 'granted') {
                            return [2 /*return*/, invokeFallback(fallback, title, options === null || options === void 0 ? void 0 : options.body) ? 'fallback' : 'blocked'];
                        }
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 8, , 9]);
                        if (!hasServiceWorkerSupport(this.$window)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.$window.navigator.serviceWorker.ready];
                    case 3:
                        _a = _b.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        _a = null;
                        _b.label = 5;
                    case 5:
                        registration = _a;
                        if (!(registration && 'showNotification' in registration)) return [3 /*break*/, 7];
                        return [4 /*yield*/, registration.showNotification(title, options || {})];
                    case 6:
                        _b.sent();
                        return [2 /*return*/, 'shown'];
                    case 7:
                        if (this.$window.Notification.permission === 'granted') {
                            // Foreground notifications are allowed when push isn't available.
                            new this.$window.Notification(title, options || {});
                            return [2 /*return*/, 'shown'];
                        }
                        return [2 /*return*/, invokeFallback(fallback, title, options === null || options === void 0 ? void 0 : options.body) ? 'fallback' : 'failed'];
                    case 8:
                        error_1 = _b.sent();
                        console.error('BrowserNotificationService.showNotification error:', error_1);
                        return [2 /*return*/, invokeFallback(fallback, title, options === null || options === void 0 ? void 0 : options.body) ? 'fallback' : 'failed'];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    return BrowserNotificationService;
}());
exports.notificationServiceFactory = [
    '$window',
    '$q',
    function ($window, $q) {
        return new BrowserNotificationService($window, $q);
    }
];
